export const RiderCompensationReasons = Object.freeze(
  [
    {
      id: 'BOOKING',
      Description: 'Customer accidently booked',
    },
    {
      id: 'VEHICLE_ISSUE',
      Description: 'Bad experience with car',
    },
    {
      id: 'DRIVER_ISSUE',
      Description: 'Bad experience with driver',
    },
    {
      id: 'DELAY',
      Description: 'Delay',
    },
    {
      id: 'CANCELLATION_POLICY_EXCEPTION',
      Description: 'Cancellation policy exception',
    },
    {
      id: 'RIDER_INCENTIVE',
      Description: 'Rider incentive',
    },
  ].sort((a, b) => a.Description.localeCompare(b.Description)),
);
